import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ModalComponent } from './directives/modal/modal.component';
import { ModalService } from './directives/modal/modal.service';
import { TooltipDirective } from './directives/tooltip/tooltip.directive';

@NgModule({
	declarations: [ModalComponent, TooltipDirective],
	exports: [ModalComponent, TooltipDirective],
	imports: [CommonModule],
	providers: [ModalService]
})
export class SharedModule {}
